// @ts-ignore
// @ts-nocheck
import {
  applySnapshot,
  cast,
  flow,
  getEnv,
  getSnapshot,
  types,
} from "mobx-state-tree";
import { PaymentInfoStore } from "../paymentInfo";
import { Availability } from "../schedule";
import InterpretDataInfo from "./interpretData";
import {
  ActiveBooking,
  TestimonialStore,
  TutorCertification,
  TutorEducation,
  TutorSubject,
  TutorWorkHistory,
} from "./tutor";
import { getTutorPrice } from "./utils/tutor-fns";

export const SearchResultType = types
  .model("SearchResultType", {
    // userId: types.identifier,
    userId: types.optional(types.string, ""),
    lastName: types.optional(
      types.union(
        types.string,
        types.maybeNull(types.string),
        types.maybe(types.string),
      ),
      "",
    ),
    firstName: types.optional(types.string, ""),
    email: types.optional(types.string, ""),
    phone: types.optional(types.string, ""),
    gender: types.optional(types.string, ""),
    photo: types.optional(types.string, ""),
    level: types.optional(types.string, ""),
    delivery: types.array(types.string),
    dateOfBirth: types.optional(types.string, ""),
    successScore: types.optional(types.number, 0),
    distance: types.maybeNull(types.optional(types.number, 0)),
    rating: types.optional(types.number, 0),
    ratingCount: types.optional(types.number, 0),
    isIdVerified: types.maybeNull(types.boolean),
    isBackgroundChecked: types.optional(types.boolean, false),
    videoIntro: types.maybeNull(types.string),
    lessonsTaught: types.optional(types.number, 0),
    students: types.optional(types.number, 0),
    isIndemand: types.optional(types.boolean, false),
    newTutorDiscount: types.optional(types.number, 0),
    isNewTutor: types.optional(types.boolean, false),
    country: types.optional(types.string, ""),
    state: types.optional(types.string, ""),
    region: types.optional(types.string, ""),
    vicinity: types.optional(types.string, ""),
    specialNeedExpertise: types.optional(types.array(types.string), []),
    examsExperience: types.optional(types.array(types.string), []),
    curriculum: types.optional(types.array(types.string), []),
    classesTaught: types.optional(types.array(types.string), []),
    levelsTaught: types.optional(types.array(types.string), []),
    entranceSchools: types.optional(types.array(types.string), []),
    education: types.optional(types.array(TutorEducation), []),
    workHistory: types.optional(types.array(TutorWorkHistory), []),
    certification: types.optional(types.array(TutorCertification), []),
    subject: types.optional(TutorSubject, {}),
    subjectList: types.optional(types.array(types.string), []),
    testimonials: types.optional(types.array(TestimonialStore), []),
    requestPending: types.optional(types.number, 0),
    requestsDeclined: types.optional(types.number, 0),
    totalJobsAssigned: types.optional(types.number, 0),
    totalJobsAccepted: types.optional(types.number, 0),
    requestsNotResponded: types.optional(types.number, 0),
    fetched: types.optional(types.boolean, false),
    activeBookings: types.optional(types.array(ActiveBooking), []),
    maxDays: types.optional(types.number, 0),
    maxHours: types.optional(types.number, 0),
    maxStudents: types.optional(types.number, 0),
    lastCalendarUpdate: types.optional(types.string, ""),
    availability: types.optional(Availability, {}),
    specialities: types.optional(types.array(types.string), []),
    otherDetails: types.optional(InterpretDataInfo, {}),
    rank: types.optional(types.maybeNull(types.number), 0),
    experience: types.optional(types.maybeNull(types.number), 0),
    age: types.optional(types.maybeNull(types.number), 0),
    eduDegrees: types.optional(types.array(types.maybeNull(types.string)), []),
    eduGrades: types.optional(types.array(types.maybeNull(types.string)), []),
    eduCountries: types.optional(
      types.array(types.maybeNull(types.string)),
      [],
    ),
    totalAmount: types.optional(types.number, 0),
    lessons: types.optional(types.number, 0),
    address: types.optional(types.maybeNull(types.string), ""),
    exemptedAreas: types.optional(
      types.array(types.maybeNull(types.string)),
      [],
    ),
    paymentInfo: types.optional(types.maybeNull(PaymentInfoStore), {}),
    whatsappNumber: types.optional(types.maybeNull(types.string), ""),
    tutor_description: types.optional(types.maybeNull(types.string), ""),
    trackRecords: types.optional(types.maybeNull(types.string), ""),
  })
  .views((self) => {
    return {
      get transformedTestimonials() {
        return getSnapshot(self.testimonials);
      },
      get tutorPricingData() {
        return {
          subject: getSnapshot(self.subject),
          level: self.level,
        };
      },
      get preciseInfo() {
        return {
          firstName: self.firstName,
          lastName: self.lastName,
          photo: self.photo,
          level: self.level,
        };
      },
      get activeSubjects() {
        let result = self.subject.skills_with_status
          .filter((o) => o.status.toLowerCase() === "active")
          .map((j) => j.name);
        return result;
      },
      isActiveSubject(subject: string) {
        let found = self.skills_with_status.find(
          (o) => o.name.toLowerCase() === subject.toLowerCase(),
        );
        return found;
      },
      oldFlowSearchTutorData(requestData, searchObj) {
        let result = getSnapshot(self.otherDetails);
        return {
          ...result,
          userId: self.userId,
          price: {
            scheduleIsSet: true,
            lessons: self.lessons,
            amount: self.totalAmount,
            // extraStudentTuition,
            // tuitionPerStudent,
            // students: numberOfStudents,
            // chargePerLesson,
          },
        };
      },
      rawCalculateTuitionFee(hourlyRate, requestData, searchObj) {
        let { amount } = getTutorPrice(
          {
            subject: {
              hourlyRate,
              discountForExtraStudents: self.subject.discountForExtraStudents,
            },
          },
          requestData,
          searchObj,
        );
        return Math.round(amount);
      },
      searchTutorData(requestData, searchObj) {
        let result = getSnapshot(self.otherDetails);
        return {
          ...result,
          userId: self.userId,
          price: getTutorPrice(getSnapshot(self), requestData, searchObj),
        };
        // let data = interpretTutorData(
        //   getSnapshot(self),
        //   requestData,
        //   searchObj
        // );
        // return { ...data, userId: self.userId };
      },
    };
  })
  .actions((self) => {
    const { adapter } = getEnv(self);
    const fetchTestimonials = flow(function* fetchTestimonials() {
      if (!self.fetched) {
        try {
          self.testimonials = [];
          let result = yield adapter.getTestimonials(self.userId);
          self.certification = cast(result.certifications);
          self.testimonials = cast(
            result.testimonials.map((o) => ({
              ...o,
              response: o.response || null,
            })),
          );
          self.fetched = true;
        } catch (error) {
          console.log(error);
        }
      }
    });

    return {
      setNewRate(newRate, additionalInfo?: any) {
        self.subject.hourlyRate = newRate;
        if (additionalInfo) {
          applySnapshot(self, { ...getSnapshot(self), ...additionalInfo });
        }
      },
      updateSubject(info) {
        applySnapshot(self.subject, { ...getSnapshot(self.subject), ...info });
      },
      fetchTestimonials,
    };
  });

export default SearchResultType;
